export default __webpack_public_path__ + "static/media/whats-next.0ea4a924.svg";